// src/notifications.js
// Handles requesting permission, saving the token, and listening to foreground messages.

import "./firebase"; // ensures Firebase app is initialized
import { getApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported,
} from "firebase/messaging";
import {
  getFirestore,
  doc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";

// 🔑 Your Web Push certificate (VAPID public key)
const VAPID_PUBLIC_KEY =
  "BFRfnMBD9OcC6s0vyi4jQGR_d1Dm6vr_TbyQYl--2nDbPaMGEMHM8yxlYse9aUC18e3shAMgJBhQKOO7YLU2sVs";

/**
 * Ask for browser permission, get an FCM token, and save it to Firestore
 * as devices/{token}.
 */
export async function initPushForThisDevice(userIdOrAnon = "anon") {
  if (!(await isSupported())) return { ok: false, reason: "unsupported" };

  const app = getApp();
  const messaging = getMessaging(app);

  // Ask permission
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return { ok: false, reason: "denied" };

  // Get token
  const token = await getToken(messaging, { vapidKey: VAPID_PUBLIC_KEY });
  if (!token) return { ok: false, reason: "no_token" };

  // Save to Firestore
  const db = getFirestore(app);
  await setDoc(
    doc(db, "devices", token),
    {
      token,
      user: userIdOrAnon,
      platform: "web-twa",
      createdAt: serverTimestamp(),
    },
    { merge: true }
  );

  return { ok: true, token };
}

/**
 * Listen for FCM messages while the app is in the foreground.
 * Returns an unsubscribe function.
 */
export async function onForegroundMessage(handler) {
  if (!(await isSupported())) return () => {};
  const app = getApp();
  const messaging = getMessaging(app);
  const unsubscribe = onMessage(messaging, handler);
  return unsubscribe;
}
